<template>
  <div
    class="config-container"
    v-if="open"
  >
    <a-tabs v-model:activeKey="activeTabKey">
      <a-tab-pane
        key="normal"
        tab="标准"
        v-if="enable_view_types.includes('normal')"
      >
        <ViewsConfig
          v-if="state?.config && tableMode === 'normal'"
          :view_key="view_key"
          :view_flag_name="state.config.title"
          :tableProState="state"
          :eventBus="eventBus"
          :hashPrefix="''"
        />
      </a-tab-pane>
      <a-tab-pane
        key="pivot"
        tab="透视表"
        v-if="enable_view_types.includes('pivot')"
      >
        <ViewsConfig
          v-if="state?.config && tableMode === 'pivot'"
          :view_key="view_key"
          :view_flag_name="state.config.title"
          :tableProState="state"
          :eventBus="eventBus"
          :hashPrefix="'pivot:'"
        />
      </a-tab-pane>
      <a-tab-pane
        key="pivot_charts"
        tab="透视图"
        v-if="enable_view_types.includes('pivot_charts')"
      >
        <ViewsConfig
          v-if="state?.config && tableMode === 'pivot_charts'"
          :view_key="view_key"
          :view_flag_name="state.config.title"
          :tableProState="state"
          :eventBus="eventBus"
          :hashPrefix="'pivotcharts:'"
        />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, watch, PropType } from 'vue';
import ViewsConfig from './viewsConfig.vue';

const props = defineProps({
  open: {
    type: Boolean,
    default: true,
  },
  eventBus: {
    type: Object as PropType<any>,
    default: () => null,
  },
  tableMode: {
    type: String as PropType<string | undefined>,
    default: 'normal',
  },
  pageConfig: {
    type: Object as PropType<any>,
    default: () => null,
  },
});

const emit = defineEmits(['update:open', 'columnsChange', 'update:tableMode']);
const enable_view_types = computed(() => props.pageConfig?.enable_view_types || []);
const tableMode = defineModel('tableMode');
const activeTabKey = computed({
  get: () => {
    if (!props.pageConfig?.enable_view_types?.length) {
      return undefined;
    }
    const currentType = props.tableMode || props.pageConfig?.default_view_type || 'normal';
    const isFind = props.pageConfig?.enable_view_types?.includes(currentType);
    if (!isFind) {
      return props.pageConfig?.enable_view_types[0];
    } else {
      return currentType;
    }
  },
  set: val => {
    emit('update:tableMode', val);
  },
});

// Sync active tab with tableMode
watch(
  () => props.tableMode,
  newMode => {
    if (newMode === 'pivot') {
      activeTabKey.value = 'pivot';
    } else if (newMode === 'pivot_charts') {
      activeTabKey.value = 'pivot_charts';
    } else {
      activeTabKey.value = 'normal';
    }
  },
  { immediate: true },
);

const state = inject<any>('tableProStateProxy');

const view_key = computed(() => {
  return `table_pro_${state.value?.config?.key}`;
});
</script>

<style scoped lang="less">
.config-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  justify-content: space-between;
  :deep(.ant-tabs) {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
    .ant-tabs-nav {
      padding: 0 10px;
      flex-shrink: 0;
    }
    .ant-tabs-content-holder {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .ant-tabs-content-top {
      min-height: 100%;
    }
  }
}
.left-extra {
  margin-right: 10px;
}

:deep(.ant-tabs-nav) {
  margin-bottom: 0;
}
</style>
